import React, {useState} from 'react'
import moment from 'moment'
import {DeleteIcon, EditIcon} from 'Atoms'
import {Link} from 'react-router-dom';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import DeleteModal from "./DeleteModal";

const CostCenterListItem = ({modelListItem, index}) => {
  const {
    id,
    identifier,
    owner_terminated,
    company_code,
    aws_gl,
    gcp_gl,
    azure_gl,
    cloud_contact_email,
    approved,
    business_unit_name,
    department_name,
    active_at,
    expired_at,
    replacement_cost_center,
    alternate_cost_center, 
    created_at,
  } = modelListItem
  const url = "/auth/edit/cost_centers/" + id

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);


  const toggleModal = () =>  {
    setModalOpen(!modalOpen)
  }

  function editAction() {
    return <Link to={url}><EditIcon/></Link>;
  }

  return (
    <tr key={index}>
      <td>{identifier}</td>
      <td>{company_code}</td>
      <td>{aws_gl}</td>
      <td>{gcp_gl}</td>
      <td>{azure_gl}</td>
      <td>{cloud_contact_email}</td>
      <td>{approved ? "True" : "False"}</td>
      <td>{owner_terminated ? "True" : "False"}</td>
      <td>{business_unit_name}</td>
      <td>{department_name}</td>
      <td>{active_at !== null ? moment(active_at).format('DD-MMM-yyyy') : ' '}</td>
      <td>{expired_at !== null ? moment(expired_at).format('DD-MMM-yyyy') : ' '}</td>
      <td>{replacement_cost_center}</td>
      <td>{alternate_cost_center}</td>
      <td>{created_at !== null ? moment(created_at).format('DD-MMM-yyyy') : ' '}</td>
      <td>{
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
          <DropdownToggle caret>
            Actions
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem>{editAction()}</DropdownItem>
            <DropdownItem divider/>
            <DropdownItem onClick={() => toggleModal()}><DeleteIcon/></DropdownItem>
          </DropdownMenu>
        </Dropdown>
      }</td>
      <DeleteModal
        modelListItem={modelListItem}
        modalOpen={modalOpen}
        toggleModal={toggleModal}
        modelId={id}
      />
    </tr>
  )
}

export default CostCenterListItem